import { useEffect } from 'react';
import { destroyCruiseGtag, initCruiseGtag } from '../../utils/cruiseGtag';

/**
 * Google Ads tag — mounts only on /cruises routes.
 * Injected at runtime; not loaded on car rental or explore pages.
 */
export default function CruiseGtagTracker() {
  useEffect(() => {
    const detachClicks = initCruiseGtag();
    return () => {
      detachClicks();
      destroyCruiseGtag();
    };
  }, []);

  return null;
}
